import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchByPage(data) {
    return request({
        url: "/base/interfaceCenter/findInterFaceUserInfoByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}

/**
 * 删除
 * @param {*} data
 */
export function DeleteInterfaceUserInfo(data) {
    return request({
        url: "/base/interfaceCenter/deleteInterfaceUserInfoBatch",
        method: "post",
        data
    });
}

/**
 * 获取所有企业信息
 * @param {*} data
 */
export function FetchAllCustomer() {
    return request({
        url: "/base/compary/findAllComparys",
        method: "post",
    });
}

/**
 * 获取接口信息数据
 * @param {*} data
 */
export function FetchAllInterfaceInfo(data) {
    return request({
        url: "/base/interfaceCenter/findAllInterfaceInfo",
        method: "post",
        data
    });
}

/**
 * 保存
 * @param {*} data
 */
export function SaveInterfaceUserInfo(data) {
    return request({
        url: "/base/interfaceCenter/saveInterfaceUserInfo",
        method: "post",
        headers: {type: "json"},
        data
    });
}

/**
 * 修改时，先获取信息
 * @param {*} data
 */
export function FetchInterfaceUserInfoByAppId(data) {
    return request({
        url: "/base/interfaceCenter/findInterfaceUserInfoByAppId",
        method: "post",
        data
    });
}

export  function  ChangeStatus(data){
    return request({
        url: "/base/interfaceCenter/changeStatus",
        method: "post",
        data
    });
}